export { default as StaticHTML } from './StaticHTML';



// WEBPACK FOOTER //
// ./src/components/StaticHTML/index.ts